import React from 'react';
import './styles/PaymentSettingsLanding.css';
import { useAuth } from '../../../context/AuthContext';
import DepositSettings from './DepositSettings';
import TipSettings from './TipSettings';

const PaymentSettingsLanding = ({ onSelectOption }) => {
  const { user } = useAuth();
  const isSpecialAdmin = !!user?.isSpecialAdmin;

  const paymentGateways = [
    {
      id: 'deluxe',
      label: 'Deluxe',
      description: 'Configure your Deluxe payment gateway',
      image: '/authorizenet.jpg',
      icon: null
    },
    ...(isSpecialAdmin ? [{
      id: 'gateway-environments',
      label: 'Gateway Environments',
      description: 'Switch Deluxe between production and sandbox',
      image: '/moneystack.png',
      icon: null
    }] : [])
  ];

  const handleOptionClick = (optionId) => {
    if (onSelectOption) {
      onSelectOption(optionId, 'payments');
    }
  };

  const renderOptionCard = (option) => (
    <button
      key={option.id}
      className="payment-option-card"
      onClick={() => handleOptionClick(option.id)}
      type="button"
    >
      <div className="payment-option-icon-wrapper">
        {option.image ? (
          <img
            src={option.image}
            alt={option.label}
            className={`payment-option-image ${option.id === 'deluxe' || option.id === 'authorize' ? 'payment-option-image--authorize' : ''}`}
          />
        ) : (
          <div className={`payment-option-icon payment-option-icon--${option.icon}`}>
            {option.icon === 'credit-card' && (
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="currentColor"/>
              </svg>
            )}
            {option.icon === 'account-balance' && (
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 10V20H8V10H4ZM10 4V20H14V4H10ZM16 13V20H20V13H16Z" fill="currentColor"/>
              </svg>
            )}
            {option.icon === 'attach-money' && (
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C13.28 6.9 13.94 7.75 14 9H16.21C16.14 7.28 15.09 5.7 13 5.19V3H10V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.44 17.1 8.63 16.18 8.5 15H6.32C6.44 17.19 8.08 18.42 10 18.83V21H13V18.85C14.95 18.5 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.5 11.8 10.9Z" fill="currentColor"/>
              </svg>
            )}
          </div>
        )}
      </div>
      <h3 className="payment-option-label">{option.label}</h3>
      <p className="payment-option-description">{option.description}</p>
    </button>
  );

  return (
    <div className="payment-settings-landing">
      <div className="payment-settings-header">
        <h1 className="payment-settings-title">Payment Settings</h1>
        <p className="payment-settings-description">
          Connect payment gateways, then configure deposits and tips—all on this page.
        </p>
      </div>

      <section className="payment-settings-section">
        <h2 className="payment-settings-category-title">Payment gateways</h2>
        <p className="payment-settings-category-description">
          Online checkout for deposits, pre-payments, and card-present flows where supported.
        </p>
        <div className="payment-options-grid">
          {paymentGateways.map(renderOptionCard)}
        </div>
      </section>

      <section className="payment-settings-section payment-settings-section--subpage">
        <h2 className="payment-settings-category-title">Deposits</h2>
        <p className="payment-settings-category-description">
          Default deposit rules for bookings. Override per service in Manage Services.
        </p>
        <DepositSettings embedded />
      </section>

      <section className="payment-settings-section payment-settings-section--subpage">
        <h2 className="payment-settings-category-title">Tips</h2>
        <p className="payment-settings-category-description">
          Tipping options shown to clients during checkout where your gateway supports tips.
        </p>
        <TipSettings embedded />
      </section>
    </div>
  );
};

export default PaymentSettingsLanding;
